import { Toaster } from "sileo";
import { useMediaQuery } from "@/hooks/use-media-query";

export default function Notifications() {
  // On mobile the panel's header (Volver / Editar / Confirmar pills)
  // sits at the top — a top-anchored toast covers those exact targets
  // for as long as it sticks. Bottom-center keeps them clear. Desktop
  // stays at top-center where the operator's primary attention is.
  // Default duration is short enough that the toast doesn't camp on
  // the screen across multiple actions; per-call ``duration`` (e.g.
  // the Undo window) still wins.
  const isMobile = useMediaQuery("(max-width: 767px)");
  return (
    <Toaster
      position={isMobile ? "bottom-center" : "top-center"}
      theme="light"
      options={{ duration: 2500 }}
    />
  );
}
